<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Team" />
            <TeamComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import TeamComp from '../Team/TeamComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'TeamPage',
    components: {
        NavBar,
        PageTitle,
        TeamComp,
        FooterComp,
    }
}
</script>